module.exports = __webpack_public_path__ + "static/img/groundB.3ccdd85b.png";